import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";

export const productionAllocProcessAssocObj = "productAllocProcess";
export const styleProductionAllocAssocObj = "productionAlloc";

export const productionAllocationTypes = {
	FOB: { name: "FOB", key: "FOB" },
	JOB_WORK: { name: "JOB WORKER", key: "JOB_WORK" },
	OWN_PRODUCTION: { name: "OWN PRODUCTION", key: "OWN_PRODUCTION" },
};

export const lsProductionAllocFilterValStr = "production_alloc_table_filter_obj";
export const lsProductionAllocAttrsValStr = "production_alloc_table_attr";
export const producAllocTableColumns = {
	production_type: {
		name: "Production Type",
		key: "production_type",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
		[selectOptionsKeyName]: {
			type: arrType,
			list: Object?.keys(productionAllocationTypes)?.map((row) => productionAllocationTypes[row]),
		},
	},
	cost: {
		name: "Cost",
		key: "cost",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	cost_sheet_url: {
		name: "Cost Sheet Url",
		key: "cost_sheet_url",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
};
